/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

// Browser polyfill for process.env (TanStack Router & Node dependencies)
if (typeof window !== "undefined") {
  const win = window as unknown as { process?: { env?: Record<string, string> } };
  win.process = win.process || {};
  win.process.env = win.process.env || {};
  win.process.env.NODE_ENV = win.process.env.NODE_ENV || (import.meta.env?.NODE_ENV as string) || "development";
}

import "./i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
